import { Component, Input, OnInit, signal } from '@angular/core';
import { AuthService, UserInfo } from 'src/app/auth/auth.service';
import { AIPrompt, ChatMessage, UpdateMessageType, WebsocketService } from 'src/app/services/utils/websocket.service';

@Component({
  selector: 'chat-box',
  templateUrl: './chat-box.component.html',
  styleUrls: ['./chat-box.component.css']
})
export class ChatBoxComponent implements OnInit{

  @Input() isConnected: boolean;
  @Input() isLive: boolean;
  message: string = '';
  isTyping: boolean = false;
  chat = signal<boolean>(false);
  messages: ChatMessage[] = [];
  userInfo: UserInfo;

  constructor(private websocketService: WebsocketService, private authService: AuthService){}


  toggleChat(){
    const value = this.chat();
    this.chat.set(!value);
  }

  showChat(){
    this.chat.set(true);
  }

  hideChat(){
    this.chat.set(false);
  }

  async sendQuickMessage(message: string){
    this.message = message;
    this.sendBotMessage();
  }

  handleKeyPress(event: KeyboardEvent){
    if (event.key === 'Enter' && !event.shiftKey) {
      event.preventDefault();
      this.sendMessage();
    }
  }


  adjustTextareaHeight(something: Event){
    /*
    this.isTyping = true;
    setTimeout(() =>{
      this.isTyping = false;
    }, 5000);
    */
  }

  async sendEntireConvo(){

    const sender: string = this.userInfo.member ? 'm:' + this.userInfo.uid : 'u:' + this.userInfo.uid;
    const updateMessage = this.websocketService.prepConvoHistory(this.userInfo.instance, this.userInfo.uid, sender, this.messages);
    this.websocketService.sendUpdate(updateMessage);

  }

  async sendMessage(){
    if(this.isLive){
      this.sendLiveMessage();
    }else{
       this.sendBotMessage();
    }

   
  }

  async sendLiveMessage(){

    let message: ChatMessage = {
      chatId: this.userInfo.instance,
      senderId: this.userInfo.chatId,
      sender: this.userInfo.username,
      text: this.message,
      status: 'outgoing',
      timestamp: new Date()
    };
    
    this.messages.push(message);
    

    const updateMessage = this.websocketService.prepMessage(message.chatId, this.userInfo.uid, message.senderId, message.sender, message.text);
    this.websocketService.sendUpdate(updateMessage);
    this.message = '';
  }

  /**
   * This is AI so sender will be left as user
   */
  async sendBotMessage(){
     let prompt: AIPrompt = {
      prompt: this.message,
      messages: this.websocketService.getAiMessages(this.messages)
    }

    let message: ChatMessage = {
      chatId: this.userInfo.instance,
      senderId: this.userInfo.chatId,
      sender: 'user',
      text: this.message,
      status: 'outgoing',
      timestamp: new Date()
    };

    this.messages.push(message);
    this.message = '';
    this.isTyping = true;

    const aiResponse = await this.websocketService.getAIChatBotResponse(prompt);
    if(aiResponse){
      this.isTyping = false;
      const senderId: string = this.userInfo.member ? 'm:' + this.userInfo.uid : 'u:' + this.userInfo.uid;

      const text: string = aiResponse.choices[0].message.content;
      let response: ChatMessage = {
        chatId: this.userInfo.instance,
        senderId: senderId,
        text: text,
        sender: 'assistant',
        status: 'incoming',
        timestamp: new Date()
      }  
      this.messages.push(response);
    }
  }

  showTypingIndicators(){
    this.isTyping = true;
  }
  hideTypingIndicators(){
    this.isTyping = false;
  }

  scrollToBottom(){

  }
  listenToUpdates(){
    this.websocketService.getUpdateMessages()
    .subscribe(update =>{

      if(update && update.type === UpdateMessageType.MESSAGE && update.senderId !== this.userInfo.chatId){
        const message: ChatMessage = JSON.parse(update.data);
        this.messages.push(message);
      }
    })
  }

  async ngOnInit(): Promise<void> {
    this.userInfo = await this.authService.getUserData();
    if(this.isLive){
      this.listenToUpdates();
    }
    
  }

}
